module.exports = __webpack_public_path__ + "static/media/seats.e08d00ab.svg";